<div class="ui-g job-details-container">
  <div *ngIf="selectedTask" class="ui-g-12">
    <div style="display: flex">
      <div class="ttd flex-shrink-1">
        <div class="route-info-param">Type:</div>
        <div class="route-info-value">{{ getTaskType() }}</div>
      </div>
      <div class="ttd flex-shrink-1">
        <div class="route-info-param">Distance:</div>
        <div class="route-info-value">{{ routeInfo.distanceMiles }} miles</div>
      </div>
      <div class="ttd flex-grow-1">
        <div class="route-info-param">Estimated Time:</div>
        <div class="route-info-value">{{ routeInfo.time }}</div>
      </div>

      <div class="flex-shrink-1 pdf-split-button">
        <button
          pButton
          *ngIf="organisationTypeId == 2 && !hasAssignedSupplier() && !hideEditLocation"
          (click)="editLocations(selectedTask.id)"
          label="Edit Locations"
          class="ui-button btn-to-right"
          [disabled]="isJobCompleted(jobInfo) || !selectedTask"
        ></button>
        <p-splitButton
          (onClick)="downloadTrack(false)"
          *ngIf="showOrderTrack"
          [disabled]="pdfDownloading"
          [model]="pdfLinkData"
          icon="{{ getPDFIcon() }}"
          label="PDF"
          styleClass="pdf-button mt-1 ui-sm-12 ui-widget ui-state-default ui-corner-all ui-button-secondary pull-right"
        >
        </p-splitButton>
      </div>

      <div class="flex-shrink-1">
        <p-splitButton
          (onClick)="visitURL(selectedTask.checklist.infoURL)"
          *ngIf="showOrderTrack && selectedTask.checklistId > 0 && selectedTask.checklist?.infoURL"
          [label]="'Workflow ' + selectedTask.vehicle.registrationNumber"
          [model]="workFlows"
          icon="fa fa-external-link"
          styleClass="pdf-button mt-1 ui-sm-12 ui-widget ui-state-default ui-corner-all ui-button-secondary pull-right"
        >
        </p-splitButton>
      </div>

      <div class="flex-shrink-1">
        <button
          (click)="ShowTrackURL()"
          *ngIf="showOrderTrack"
          class="pull-right ui-sm-12 mt-1"
          label="Order Track URL"
          pButton
          type="button"
        ></button>
      </div>
      <div class="flex-shrink-1">
        <button
          (click)="recordCustomerInfo()"
          *ngIf="showOrderTrack && organisationTypeId == 1"
          class="pull-right ui-sm-12 mt-1 mr-2"
          label="Delay/Failure Notification"
          [ngClass]="selectedTask.requiresDelayFailureReason ? 'highlight' : 'lowlight'"
          pButton
          type="button"
        ></button>
      </div>
    </div>
    <div style="display: flex" class="ui-g-6 ui-lg-6 ui-sm-12">
      <div class="flex-shrink-1">
        <span *ngIf="selectedTask">
          <div
            *ngFor="let x of selectedTask.checklist?.orgStepChecklistSubCategories"
            style="margin-top: 7px; margin-right: 7px"
          >
            <checklist-category-item
              [subCategory]="x.checklistSubCategory"
            ></checklist-category-item>
          </div>
        </span>
      </div>
      <div
        *ngIf="
          selectedTask?.checklist?.groupName && (organisationTypeId == 1 || organisationTypeId == 2)
        "
        style="margin-top: 6px; margin-bottom: 3px"
        class="flex-shrink-1 checklist-groupname-style"
      >
        <div>
          {{ selectedTask?.checklist?.groupName }}
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g-12 mt-2">
    <div *ngIf="selectedTask" class="ui-g-12 ui-sm-12 ui-md-12">
      <div
        *ngIf="tasks"
        [ngClass]="!isFullWidth ? 'ui-g-2 ui-sm-12 ui-md-2 mt-1' : 'ui-g-2 ui-sm-12 ui-md-2 mt-1'"
      >
        <p-listbox
          [(ngModel)]="selectedTask"
          [options]="taskSequenceEditMode ? tasksCopyForSequenceEdit : tasks"
        >
          <ng-template let-task let-i="index" pTemplate="item">
            <div class="task-sequence-count-container">
              <div
                class="task-sequence-count"
                *ngIf="task.value.taskSequence != null && !multiOrderView"
              >
                Task {{ i + 1 }}
              </div>
              <div class="task-sequence-move-buttons" *ngIf="taskSequenceEditMode">
                <button
                  class="sort-btn"
                  pButton
                  icon="fa fa-angle-up"
                  [disabled]="i == 0"
                  (click)="moveTaskSequenceUp(task)"
                ></button>
                <button
                  class="sort-btn"
                  pButton
                  icon="fa fa-angle-down"
                  [disabled]="i + 1 == tasks?.length"
                  (click)="moveTaskSequenceDown(task)"
                ></button>
              </div>
            </div>
            <div class="status" *ngIf="task.value.lastStepName && orgTypeId == 1">
              {{ task.value.lastStepName }}
            </div>
            <div class="registration">
              {{ task.value.vehicle.registrationNumber | uppercase }}
            </div>
            <div style="text-align: left; font-size: smaller">
              {{ task.value.vehicle.make }} {{ task.value.vehicle.model }}
            </div>
            <div style="text-align: left; font-size: smaller">
              {{ task.value.vehicle.kerbWeight }} kg. {{ task.value.vehicle.color }}
            </div>
            <div *ngIf="organisationTypeId == 1" style="text-align: left; font-size: smaller">
              {{ task.value.regStatusName }}
            </div>
          </ng-template>
        </p-listbox>

        <div
          *ngIf="
            tasks.length > 1 &&
            multiOrderView == false &&
            (organisationTypeId == OrganisationTypeEnum.Engineius ||
              organisationTypeId == OrganisationTypeEnum.Customer ||
              organisationTypeId == 0)
          "
        >
          <div class="task-sequence-enable-options">
            <p-inputSwitch
              [disabled]="
                taskSequenceEditMode ||
                (job.statusId != 5 && this.job.id > 0) ||
                (jobInfo?.supplierId && organisationTypeId == OrganisationTypeEnum.Customer)
              "
              [(ngModel)]="taskSequencingEnabled"
              (onChange)="handleTaskSequenceToggle($event)"
            ></p-inputSwitch>
            <span class="toggle-label">Use specific task sequence</span>
          </div>
          <div
            class="task-sequence-edit"
            *ngIf="(job.statusId == 5 && this.job.id > 0) || this.job.id == 0"
          >
            <button
              type="button"
              pButton
              (click)="editTaskSequence()"
              label="Edit Task Sequence"
              class="ui-btn-secondary sequence-edit-btn-style"
              *ngIf="
                !taskSequenceEditMode &&
                taskSequencingEnabled &&
                !(jobInfo?.supplierId && organisationTypeId == OrganisationTypeEnum.Customer)
              "
            ></button>
            <button
              type="button"
              pButton
              (click)="saveTaskSequence()"
              label="Save"
              class="ui-btn-secondary sequence-edit-btn-style"
              *ngIf="taskSequenceEditMode"
            ></button>
            <button
              type="button"
              pButton
              (click)="cancelTaskSequenceEdit()"
              label="Cancel"
              class="ui-btn-secondary sequence-edit-cancel-btn-style"
              *ngIf="taskSequenceEditMode"
            ></button>
          </div>
        </div>
      </div>

      <div
        [ngClass]="
          !isFullWidth
            ? 'ui-g-5 ui-lg-4 ui-xl-4 ui-md-10 ui-sm-12 mt-1'
            : 'ui-g-10 ui-lg-10 ui-xl-10 ui-md-10 ui-sm-10 mt-1'
        "
        id="ajustementDisplayRoute"
      >
        <div style="margin-left: 10px; margin-right: 5px">
          <div
            *ngIf="selectedTask.requiresDelayFailureReason && organisationTypeId == 1"
            class="delay-notification"
          >
            This task requires a Delay/Failure notification
          </div>

          <display-route-simple
            [orgTypeId]="orgTypeId"
            [task]="selectedTask"
            [hideTaskSchedule]="hideTaskSchedule"
          >
          </display-route-simple>
        </div>
      </div>

      <div
        [ngClass]="
          !isFullWidth
            ? 'ui-g-7 ui-lg-6 ui-xl-6 ui-md-12 ui-sm-12 mt-1'
            : 'ui-g-12 ui-lg-12 ui-xl-12 ui-md-12 ui-sm-12 mt-1'
        "
        id="ajustementMap"
      >
        <div style="margin-left: 5px; margin-right: 5px">
          <map-control
            [lazyLoad]="true"
            [liveTask]="selectedTask"
            [tasks]="[selectedTask]"
            [pauses]="pauses"
            [readOnly]="true"
            *ngIf="selectedTask"
          ></map-control>

          <div *ngIf="showTaggingInfo" class="ui-g-12" style="margin-top: 10px">
            <div style="clear: both"></div>
            <div
              *ngIf="!jobTaggingInfo"
              style="width: 100%"
              style="text-align: center; font-size: 1.25rem"
            >
              <i class="fa fa-spinner fa-spin"></i>&nbsp; Loading Tagging Information
            </div>
            <div *ngIf="jobTaggingInfo">
              <table class="metric-table table-striped">
                <thead>
                  <tr>
                    <th>Capable Suppliers</th>
                    <th>Order No.</th>
                    <th>Customer</th>
                    <th>Tags</th>
                    <th>Or</th>
                    <th>Or</th>
                    <th>Not</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of jobTaggingInfo.orderRequiredTagsDTOs">
                    <td>
                      <a
                        (click)="showTaggingSuppliers(); $event.preventDefault()"
                        href="#"
                        pTooltip="Click to view list of capable suppliers"
                      >
                        {{ item.supplierCount }}
                      </a>
                    </td>
                    <td>
                      {{ item.orderNumber }}
                    </td>
                    <td>
                      {{ item.customerName }}
                    </td>
                    <td>
                      {{ item.tagSet[0] }}
                    </td>
                    <td>
                      {{ item.tagSet[1] }}
                    </td>
                    <td>
                      {{ item.tagSet[2] }}
                    </td>
                    <td>
                      {{ item.tagsNot }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="organisationTypeId != 2 && TaskTrack != 0" class="ui-g-12">
    <div class="ui-g-12">
      <h2 style="margin-top: 1.5em; margin-bottom: 0.5em">Driver Performance</h2>
      <p-chart
        [data]="DriverLineData"
        [options]="DriverLineOptions"
        height="350px"
        type="line"
      ></p-chart>
      <h2 style="margin-top: 1.5em; margin-bottom: 0.5em">Battery Performance</h2>
      <p-chart
        [data]="BatteryLineData"
        [options]="BatteryLineOptions"
        height="300px"
        type="line"
      ></p-chart>
    </div>
  </div>
</div>
<p-dialog [(visible)]="showCopyTrackURL" [style]="{ width: '650px' }" header="Order Track URLs">
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-g-12"><h4 style="padding: 0; margin: 0">Order Summary</h4></div>
    <div class="ui-grid-row">
      <div class="ui-g-12 ui-lg-10 ui-md-10" style="padding-top: 10px">
        <a href="{{ SummaryOrderUrl }}" target="_blank"
          ><span style="color: darkblue; font-weight: bold">{{ SummaryOrderUrl }}</span></a
        >
      </div>
      <textarea id="txtUrl0" style="display: none; width: 0px; height: 0px">{{
        SummaryOrderUrl
      }}</textarea>
    </div>
    <div class="ui-grid-row">
      <button
        (click)="CopyUrl(0)"
        class="ui-g-12 btn-to-right"
        icon="fa fa-files-o"
        label="Copy &nbsp; &nbsp;"
        pButton
        style="margin-left: 0px"
        type="button"
      ></button>
    </div>

    <div class="ui-grid-row">
      <div class="ui-g-12"></div>
    </div>
    <div class="ui-g-12"><h4 style="padding: 0; margin: 20px 0 0 0">Full Order Details</h4></div>
    <div class="ui-grid-row">
      <div class="ui-g-12 ui-lg-10 ui-md-10" style="padding-top: 10px">
        <a href="{{ FullOrderUrl }}" target="_blank"
          ><span style="color: darkblue; font-weight: bold">{{ FullOrderUrl }}</span></a
        >
      </div>
      <textarea id="txtUrl1" style="display: none; width: 0px; height: 0px">{{
        FullOrderUrl
      }}</textarea>
    </div>
    <div class="ui-grid-row">
      <button
        (click)="CopyUrl(1)"
        class="ui-g-12 btn-to-right"
        icon="fa fa-files-o"
        label="Copy &nbsp; &nbsp;"
        pButton
        style="margin-left: 0px"
        type="button"
      ></button>
    </div>

    <div class="ui-grid-row">
      <div class="ui-g-12"></div>
    </div>
    <div class="ui-g-12">
      <h4 style="padding: 0; margin: 20px 0 0 0">Full Order Details (No Condition)</h4>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-12 ui-lg-10 ui-md-10" style="padding-top: 10px">
        <a href="{{ FullOrderUrl }}&hd=true" target="_blank"
          ><span style="color: darkblue; font-weight: bold">{{ FullOrderUrl }}&hd=true</span></a
        >
      </div>
      <textarea id="txtUrl2" style="display: none; width: 0px; height: 0px"
        >{{ FullOrderUrl }}&hd=true</textarea
      >
    </div>
    <div class="ui-grid-row">
      <button
        (click)="CopyUrl(2)"
        class="ui-g-12 btn-to-right"
        icon="fa fa-files-o"
        label="Copy &nbsp; &nbsp;"
        pButton
        style="margin-left: 0px"
        type="button"
      ></button>
    </div>

    <div class="ui-grid-row">
      <div class="ui-g-12"></div>
    </div>
    <div class="ui-grid-row" style="padding-top: 5px">
      <div class="ui-g-12" style="text-align: center">
        <label *ngIf="showlblMsg" style="color: green; font-weight: bold; font-size: small"
          >Link copied to clipboard</label
        >
      </div>
    </div>
    <div class="ui-grid-row" style="float: right; margin-bottom: 10px; padding-top: 10px">
      <button
        (click)="showCopyTrackURL = false"
        icon="fa ui-icon-close"
        label="Close"
        pButton
        type="button"
      ></button>
    </div>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="showRecordCustomerInfo"
  (onHide)="clearDelayFailureNotesAndSelection()"
  [blockScroll]="true"
  [modal]="true"
  [style]="{ width: '750px' }"
  header="Record Delay/Failure Customer Notification"
>
  <div class="ui-g" style="margin-left: 8px; margin-bottom: 30px">
    <div class="ui-g-12" style="margin-bottom: 10px; font-weight: 500">
      {{ selectedTask?.vehicle?.make }} {{ selectedTask?.vehicle?.model }} ({{
        selectedTask?.vehicle?.registrationNumber
      }})
    </div>
    <div class="ui-g-12" style="height: 28px">
      <span style="margin-left: 2px; margin-right: -2px"
        ><i class="vme-material-icons pick-up-color">&#xe805;</i></span
      >
      {{ selectedTask?.pickupLocation?.primaryAddress }}
    </div>
    <div class="ui-g-12" style="height: 28px">
      <span><i class="vme-material-icons drop-off-color">&#xe804;</i></span>
      {{ selectedTask?.dropoffLocation?.primaryAddress }}
    </div>
  </div>

  <div class="ui-g">
    <div class="ui-g-3">Delay/Failure Category:</div>
    <div class="ui-g-9">
      <p-dropdown
        [(ngModel)]="newDelayFailureCategory"
        filter="true"
        [options]="delayFailureCategories"
        [style]="{ width: '100%' }"
        appendTo="body"
        id="delayFailure"
        name="delayFailure"
        (onChange)="onDelayFailureCategoryChange()"
      ></p-dropdown>
    </div>
  </div>

  <div class="ui-g">
    <div class="ui-g-3">Recipient Address</div>
    <div class="ui-g-9">
      <p-autoComplete
        #autocomplete
        [(ngModel)]="emailAddressResult"
        [multiple]="true"
        [dropdown]="true"
        [suggestions]="emailAddressSuggestions"
        class="email-address"
        (completeMethod)="filterEmailAddress($event)"
      ></p-autoComplete>
    </div>
  </div>

  <div style="display: flex; margin-top: 5px">
    <div style="margin-top: 2px">Notify Customer with Email:</div>
    <p-inputSwitch [style]="{ 'margin-left': '10px' }" [(ngModel)]="emailToggle"></p-inputSwitch>
  </div>

  <div class="ui-g" style="margin-top: 10px">
    <div class="ui-g-12">New Note:</div>
  </div>
  <div class="ui-g">
    <div class="ui-g-12">
      <textarea
        [(ngModel)]="newCustomerNote"
        autocapitalize="off"
        autocomplete="off"
        autocorrect="off"
        class="w-100 event-note-area"
        pInputTextarea
        rows="7"
        spellcheck="false"
      ></textarea>
    </div>
  </div>
  <p-footer>
    <div class="button-box">
      <button
        (click)="SaveNewCustomerNote()"
        class="btn-to-right"
        label="Record"
        pButton
        type="button"
      ></button>
      <button
        (click)="clearDelayFailureNotesAndSelection()"
        class="ui-button btn-to-right"
        label="Cancel"
        pButton
        type="button"
      ></button></div
  ></p-footer>
</p-dialog>

<p-dialog
  *ngIf="jobTaggingInfo"
  [(visible)]="showPotentialSuppliers"
  [modal]="true"
  [style]="{ width: '1100px', 'max-height': '900px' }"
  appendTo="body"
  header="Potential Suppliers for Job {{ job.jobNumber }}"
>
  <div class="ui-grid-row ui-grid-responsive ui-fluid">
    <p-table
      #dt
      [loading]="loading"
      [resizableColumns]="true"
      [responsive]="true"
      [value]="jobTaggingInfo.potentialSuppliers"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn>Supplier Name</th>
          <th pResizableColumn>Address</th>
          <th pResizableColumn>Postcode</th>
          <th pResizableColumn>Telephone</th>
          <th pResizableColumn>Tags</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item">
          <td>{{ item.name }}</td>
          <td>{{ getSupplierAddress(item) }}</td>
          <td>{{ item.postcode | postcode }}</td>
          <td>
            <span
              ><a href="tel:{{ item.phoneNumber }}">{{ item.phoneNumber }}</a></span
            >
          </td>
          <td>getSupplierTags(item)</td>
        </tr>
      </ng-template>
    </p-table>
    <!-- DATATABLE DEPRECATED --
    <p-dataTabl #dt [loading]="loading" [resizableColumns]="true" [responsive]="true"
                 [value]="jobTaggingInfo.potentialSuppliers">
      <p-column [filter]="true" [style]="{'width': '20%'}" field="name" filterMatchMode="contains"
                filyt header="Supplier Name">
        <ng-template let-item="rowData" pTemplate="body">
          {{item.name}}
        </ng-template>
      </p-column>
      <p-column [style]="{'width': '35%'}" header="Address">
        <ng-template let-item="rowData" pTemplate="body">
          {{getSupplierAddress(item)}}
        </ng-template>
      </p-column>
      <p-column [style]="{'width': '10%'}" header="Postcode">
        <ng-template let-item="rowData" pTemplate="body">
          {{item.postcode | postcode }}
        </ng-template>
      </p-column>
      <p-column [style]="{'width': '13%'}" header="Telephone">
        <ng-template let-item="rowData" pTemplate="body">
          <span><a href="tel:{{ item.phoneNumber }}">{{ item.phoneNumber }}</a></span>
        </ng-template>
      </p-column>
      <p-column [style]="{'width': '20%'}" header="Tags">
        <ng-template let-item="rowData" pTemplate="body">
          {{getSupplierTags(item)}}
        </ng-template>
      </p-column>
    </p-dataTable>
    --->
  </div>
</p-dialog>
